import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import NavbarPage from "../../components/Navbar/Navbar_Page";
import Social from "../../components/Social/Social";
import Footer from "../../components/Footer/footer";
import { AicpaLogo, HipaaBadge } from "../../components/TrustBadges/TrustBadges";
import backgroundImage from "../../images/slide4.png";

class RediMDSecurity extends Component {
  render() {
    return (
      <React.Fragment>
        <NavbarPage />
        <section
          className="section section-lg"
          id="home"
          style={{
            overflow: "hidden",
            height: window.innerHeight * 0.5 + "px",
            backgroundImage: `url(${backgroundImage})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
        >
          <div className="bg-overlay h-100"> </div>
          <div className="display-table">
            <div className="display-table-cell">
              <Container>
                <Row>
                  <Col lg={{ size: 8, offset: 2 }} className="text-white text-center">
                    <h1 className="home-title text-rotate">Security &amp; Compliance</h1>
                    <p className="pt-3" style={{ fontWeight: 100, fontSize: "24px", lineHeight: "36px" }}>
                      Protecting patient information is part of how we deliver care. RediMD's security controls
                      have been examined by an independent CPA firm, and our HIPAA compliance program has been
                      assessed by a third-party compliance firm.
                    </p>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </section>

        <section className="container text-muted pb-4">
          <Row className="mt-4">
            <Col>
              <h3>SOC 2® report</h3>
              <div className="my-3"><AicpaLogo /></div>
              <p>
                RediMD has received its first SOC 2® Type 2 report on the organization's controls relevant to
                security. The examination was performed by KEN &amp; Co. CPA LLC, an independent CPA firm, under
                AICPA attestation standards and covered the period May 14 to August 13, 2026.
              </p>
              <p>
                SOC 2 reports are confidential. Customers and prospective customers can request a copy, which we
                share under a nondisclosure agreement.
              </p>
              <p>
                <Link to="/contact" className="btn btn-primary">Request our SOC 2 report</Link>
              </p>
              <p>Use our contact form and mention “SOC 2 report” in your message.</p>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col>
              <h3>HIPAA</h3>
              <div className="my-3"><HipaaBadge /></div>
              <p>
                RediMD's HIPAA compliance program was assessed by Workstreet, a third-party compliance firm, in
                August 2026 against the HIPAA Privacy, Security, and Breach Notification Rules.
              </p>
              <ul className="list-unstyled">
                <li>
                  <a href="/docs/RediMD-HIPAA-Attestation-2026-08.pdf" target="_blank" rel="noopener noreferrer">
                    Download our HIPAA attestation letter (PDF)
                  </a>
                </li>
                <li><Link to="/hipaa">Read our Notice of Privacy Practices</Link></li>
              </ul>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col>
              <h3>How we protect your information</h3>
              <ul>
                <li>Patient data is encrypted in transit and at rest.</li>
                <li>Staff access to production systems requires multi-factor authentication.</li>
                <li>Access is role-based, limited to what each person needs, and reviewed quarterly.</li>
                <li>Our systems are continuously monitored for intrusions, with centralized logging.</li>
                <li>Systems are regularly scanned for vulnerabilities and patched.</li>
                <li>Disaster-recovery and incident-response plans are tested every year.</li>
                <li>All staff complete security awareness training.</li>
                <li>Our platform is hosted on Amazon Web Services in U.S. data centers.</li>
              </ul>
            </Col>
          </Row>
        </section>

        <Social />
        <Footer />
      </React.Fragment>
    );
  }
}

export default RediMDSecurity;
